/**
 * A versão do texto da saída em poucas letras (E171.F3.C01; E202.F3, GUS-145): "texto 9fa252bf", o
 * começo do `edicoes_sha256` que a emissão grava no artefato, ou "texto original" sem edição.
 */
import { ptBR } from '@/i18n/pt-BR';

const t = ptBR.editorManual;
const CARACTERES_DO_CODIGO = 8;

export function textoDaVersao(edicoesSha256: string | null): string {
  return edicoesSha256 === null
    ? t.rodape.textoOriginal
    : t.rodape.textoEditado.replace('{codigo}', edicoesSha256.slice(0, CARACTERES_DO_CODIGO));
}
